"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseMarkdown;
var _luxon = require("luxon");
function parseMarkdown(input) {
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var activeQuestionCount = values.activeQuestionCount,
    questionBankName = values.questionBankName;
  var subbedString = input.replace(/(%{qb})/g, questionBankName).replace(/(%{year})/g, _luxon.DateTime.now().year).replace(/(%{active_question_count})/g, activeQuestionCount);
  return subbedString;
}